import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { useMemo, Fragment, useEffect } from 'react';
import Immutable from 'immutable';
import { createGlobalStyle } from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { TEMPLATE_SECTION_DIVIDER_BORDER_COLOR } from 'HubStyleTokens/theme'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mark... Remove this comment to see the full error message

import { Header } from 'marketing-dot-com-nav';
import { MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X } from '../../constants/layout';
import { getFullPublicUrl } from '../../utils/urls';
const GlobalHeaderStyle = createGlobalStyle(_t || (_t = _`
  .hsg-page-width-normal,
  .hs-page-width-normal {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--cta {
    @media (min-width: 768px) {
      padding-right: 0;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--search {
    display: none;
  }

  .hsg-nav__group-item > #hsg-nav__logo > #hsg-nav__logo-mobile {
    display: none;
  }
`), MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X);
const MarketplaceNavStyle = createGlobalStyle(_t2 || (_t2 = _`
  #hsg-nav-2016,
  #hsg-nav-global {
    > div > nav,
    > nav {
      background-color: ${0};
      border-bottom: 1px solid ${0};
    }
  }
`), OLAF, TEMPLATE_SECTION_DIVIDER_BORDER_COLOR);
export const LANGUAGES_MAP = {
  en: 'English',
  // marketing-dot-com-nav uses jp for Japanese
  jp: '日本語',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
  fr: 'Français'
};

const MarketingNavHeader = ({
  contentBlob,
  enableConvertFlag,
  lang = 'en',
  variation = 'marketplace'
}) => {
  const HeaderComponent = useMemo(() => {
    // marketing-dot-com-nav uses jp for Japanese
    if (lang === 'ja') return Header.jp;
    if (lang in Header) return Header[lang];
    return Header.en;
  }, [lang]);
  const computedContentBlob = useMemo(() => {
    const {
      contentBlob: defaultContentBlob
    } = HeaderComponent;
    const defaultHomeUrl = getFullPublicUrl(lang);
    return Immutable.fromJS(defaultContentBlob || {}).mergeDeep(contentBlob).mergeDeep({
      upperNavContent: {
        homeUrl: defaultHomeUrl
      },
      mobileNavContent: {
        homeUrl: defaultHomeUrl
      }
    }).toJS();
  }, [HeaderComponent, contentBlob, lang]);
  useEffect(() => {
    if (contentBlob.upperNavContent && contentBlob.upperNavContent.homeUrl || contentBlob.mobileNavContent && contentBlob.mobileNavContent.homeUrl) {
      console.warn('[MarketingNavHeader] Custom homeUrl passed, using default instead.');
    }
  }, [contentBlob]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalHeaderStyle, {}), variation === 'marketplace' && /*#__PURE__*/_jsx(MarketplaceNavStyle, {}), /*#__PURE__*/_jsx(HeaderComponent, {
      contentBlob: computedContentBlob,
      enableConvertFlag: enableConvertFlag,
      isLoggedIn: false,
      variation: variation
    })]
  });
};

export default MarketingNavHeader;